import type { PdpOrderBy, SortDirection } from '@vizit/api';
import { TableHeader } from '@vizit/atoms';
import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from '@vizit/feature-flags';
import * as React from 'react';

interface ProductListingTableTheadProps {
  /**
   * Whether to show the action column
   * @default false
   */
  showActionColumn?: boolean;
  /**
   * The field currently being sorted
   * @optional
   */
  sortBy?: PdpOrderBy['field'];
  /**
   * The current sort direction
   * @optional
   */
  sortDirection?: SortDirection;
  /**
   * Callback when a sortable column header is clicked
   * @optional
   */
  onSort?: (field: PdpOrderBy['field']) => void;
}

const ProductListingTableThead = React.memo((props: ProductListingTableTheadProps) => {
  const { showActionColumn = false, sortBy, sortDirection, onSort } = props;
  const isRetailerEnabled = useFeatureFlag(FEATURE_FLAGS.APRIL_SCORING_CHANGES, false);

  const getSortDirection = (field: PdpOrderBy['field']): SortDirection | false => {
    if (sortBy === field && sortDirection) return sortDirection;
    return false;
  };

  return (
    <TableHeader>
      <TableHeader.Column isRowHeader className="w-3/5">
        Product Page
      </TableHeader.Column>
      {isRetailerEnabled && (
        <TableHeader.Column className="whitespace-nowrap w-60 text-center">Retailer</TableHeader.Column>
      )}
      <TableHeader.SortableColumn
        className="whitespace-nowrap w-60 text-center"
        sortDirection={getSortDirection('listing_score_at_ingest')}
        onSort={() => onSort?.('listing_score_at_ingest')}
      >
        Live score
      </TableHeader.SortableColumn>
      <TableHeader.SortableColumn
        className="whitespace-nowrap w-60 text-center"
        sortDirection={getSortDirection('listing_score')}
        onSort={() => onSort?.('listing_score')}
      >
        Your score
      </TableHeader.SortableColumn>
      <TableHeader.Column className="whitespace-nowrap">Change</TableHeader.Column>
      {showActionColumn && <TableHeader.Column className="w-16" />}
    </TableHeader>
  );
});

export { ProductListingTableThead };
export type { ProductListingTableTheadProps };
